import { Container, HStack, IconButton, Menu, MenuButton, MenuList } from '@chakra-ui/react'
import { TelemetryClientService } from '../services/TelemetryClientService';
import { MarkdownBlock } from '../comments/MarkdownBlock';
import { useParams } from 'react-router-dom';
import React from 'react';
import { AppBreadcrumb } from '../navbar/AppBreadcrumb';
import { AuthService } from '../services/AuthService';
import { FiMenu } from 'react-icons/fi';
import { MenuItemEditPage } from '../course/MenuItemEditPage';
import { AppContext } from '../comments/AppContext';
import { TEMPLATE } from '@/shared/constants';
import { AppLinkBar } from '../navbar/AppLinkBar';

export const MarkdownPage = () => {

  const params = useParams<{ fileName: string }>();

  const { isAuthenticated } = React.useContext(AppContext);

  const normalizeFileName = (fileName?: string) =>
    fileName
      ? fileName
        .replace(/\.[^/.]+$/, '')
        .replace(/^page[_-]?/i, '')
        .split(/[_-]/)
        .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ')
      : '';

  const isSpecialPage = params.fileName === TEMPLATE.PAGE_ABOUT || params.fileName === TEMPLATE.PAGE_RESOURCES || params.fileName === TEMPLATE.PAGE_ANALYTICS;

  const breadcrumb = React.useMemo(() => [
    isSpecialPage
      ? { href: '/', label: 'Home' }
      : { href: `/page/${TEMPLATE.PAGE_RESOURCES}`, label: 'Resources' },
    { href: `/page/${params.fileName}`, label: normalizeFileName(params.fileName) },
  ], [params.fileName]);

  TelemetryClientService.page('LearnMorePage');

  return <>
    <AppBreadcrumb breadcrumb={breadcrumb} />
    {isSpecialPage && <AppLinkBar />}
    <Container className="print-no-top-margin" style={{ marginTop: 100, minHeight: 500, position: 'relative' }}>
      {params.fileName && AuthService.isStaff && <HStack position='absolute' top={10} right={10} zIndex={99}>
        <Menu>
          <MenuButton className="no-print" as={IconButton} isDisabled={!AuthService.isAdmin} variant='ghost' icon={<FiMenu />}>Actions</MenuButton>
          <MenuList>
            <MenuItemEditPage pageId={params.fileName} />
          </MenuList>
        </Menu>
      </HStack>}
      {params.fileName && <MarkdownBlock key={`${params.fileName}-${isAuthenticated}`} templateId={params.fileName} />}
    </Container>
  </>
}